<template>
  <div class="chart-area">
    <span class="session-name mt-1">{{ name }}</span>
    <ApexCharts
      ref="chart"
      height="400px"
      width="590px"
      :options="chartOptions"
      :series="currentSeries"
    />
  </div>
</template>

<script>

import VueApexCharts from "vue3-apexcharts";

export default {
  name: 'ValidatorChartMulti',
  components: {
    ApexCharts: VueApexCharts,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isZoomed: false,
      chartOptions: {},
      currentSeries: [],
    };
  },

  watch: {
    data: {
      handler(newData) {
        if (this.$refs.chart?.updateOptions) {
          const series = newData.series;
          if (series.length !== this.currentSeries.length) {
            this.currentSeries = series;
            const options = newData;
            options.chart.width = '100%';
            options.stroke = {
              width: 2,
            };
            options.title.align = 'center';
            this.chartOptions = options;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.chart?.updateOptions) {
        const options = this.data;
        options.chart.width = '100%';
        options.stroke = {
          width: 2,
        };
        options.title.align = 'center';
        this.chartOptions = options;
      }
      window.dispatchEvent(new Event('resize'));
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.chart-area {
  width: 600px;
  height: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .session-name {
    width: 100%;
    text-align:center;
    padding: 0 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 600;
  }
}
</style>
